import React, { useState } from "react";
import { ArrowLeft, Zap } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api, { storeToken } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function Login() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const handleDemoLogin = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/demo", {});
      if (data?.session_token) {
        storeToken(data.session_token);
      }
      setUser(data.user);
      toast.success(`Selamat datang, ${data.user.name}!`);
      navigate("/onboarding", { replace: true, state: { user: data.user } });
    } catch (err) {
      console.warn("[login] demo login failed:", err?.message);
      toast.error("Gagal masuk demo");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090B] text-foreground flex flex-col">
      <div className="absolute top-6 left-6">
        <button onClick={() => navigate("/")} data-testid="back-btn" className="h-10 w-10 rounded-full bg-secondary border border-border flex items-center justify-center">
          <ArrowLeft className="h-5 w-5" />
        </button>
      </div>

      <div aria-hidden className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute left-1/2 -translate-x-1/2 top-20 h-[400px] w-[400px] rounded-full bg-primary/20 blur-[100px]" />
      </div>

      <div className="relative flex-1 flex flex-col items-center justify-center px-6">
        <div className="h-16 w-16 rounded-3xl bg-primary glow-cyan-strong flex items-center justify-center mb-6">
          <span className="font-heading font-black text-2xl text-black">J</span>
        </div>
        <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tight text-center">Masuk ke JoinPlay</h1>
        <p className="mt-3 text-muted-foreground text-center max-w-sm">
          Login cepat. Sekali masuk, langsung gas cari match.
        </p>

        {/* Demo button — primary while Google OAuth is being whitelisted for custom domain */}
        <button
          data-testid="demo-login-btn"
          onClick={handleDemoLogin}
          disabled={loading}
          className="mt-8 w-full max-w-sm inline-flex items-center justify-center gap-2 px-6 py-4 rounded-full bg-primary text-primary-foreground font-bold glow-cyan-strong active:scale-95 transition-transform disabled:opacity-50"
        >
          <Zap className="h-4 w-4" /> {loading ? "Memuat..." : "Coba Sekarang (Demo)"}
        </button>
        <p className="mt-2 text-[11px] text-muted-foreground text-center">
          Bypass login — buat akun demo, langsung gas
        </p>

        {/* Divider */}
        <div className="my-5 flex items-center gap-3 w-full max-w-sm">
          <div className="flex-1 h-px bg-border" />
          <div className="text-xs text-muted-foreground font-bold uppercase tracking-wider">atau</div>
          <div className="flex-1 h-px bg-border" />
        </div>

        <button
          data-testid="google-login-btn"
          onClick={handleGoogleLogin}
          className="w-full max-w-sm inline-flex items-center justify-center gap-3 px-6 py-3.5 rounded-full bg-white text-black font-bold active:scale-95 transition-transform"
        >
          <svg className="h-5 w-5" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Lanjutkan dengan Google
        </button>
        <p className="mt-2 text-[11px] text-muted-foreground text-center max-w-xs">
          Tip: Buka di browser HP (Safari/Chrome), bukan in-app webview, biar Google login lancar.
        </p>
      </div>
    </div>
  );
}
